import { useEffect, useState } from "react";
import Input from "./form/input";
import { useNavigate, useOutletContext } from "react-router-dom";
import Swal from "sweetalert2";

const SignUp = () => {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");

    // functions from App component
    // to transit values of JWT and errors to App component
    const { setAlertClassName } = useOutletContext();
    const { setAlertMessage } = useOutletContext();

    // delete all the previous errors
    useEffect(() => {
        setAlertClassName("d-none"); // hide alert if it was
        setAlertMessage("");
    }, [setAlertClassName, setAlertMessage]);



    const handleSubmit = (event) => {
        event.preventDefault();

        // Validation 

        // check if the fields are not empty
        if (password === "" || email === "" || confirmPassword === "" || firstName === "" || lastName === "") {
            setAlertClassName("alert-danger");
            setAlertMessage("All fields must be filled in!");
            return
        }
        // check if passwords are similar
        if (password !== confirmPassword) {
            setAlertClassName("alert-danger");
            setAlertMessage("Passwords are not the same!");
            return
        }
        // check if passwords are too long
        if (password.length > 50 || confirmPassword.length > 50) {
            setAlertClassName("alert-danger");
            setAlertMessage("Password is too long!");
            return
        }
        // check if password is too weak
        if (password.length < 3 || confirmPassword.length < 3) {
            setAlertClassName("alert-danger");
            setAlertMessage("Password is extremely weak!");
            return
        }

        // check if first name is too long
        if (firstName.length > 50) {
            setAlertClassName("alert-danger");
            setAlertMessage("First name is too long!");
            return
        }
        // check if first name is too short
        if (firstName.length < 3) {
            setAlertClassName("alert-danger");
            setAlertMessage("First name can't be less then 3 symbols!");
            return
        }

        // check if last name is too long
        if (lastName.length > 50) {
            setAlertClassName("alert-danger");
            setAlertMessage("Last name is too long!");
            return
        }
        // check if last name is too short
        if (lastName.length < 3) {
            setAlertClassName("alert-danger");
            setAlertMessage("Last name can't be less then 3 symbols!");
            return
        }

        //  create the request payload
        //  email and password are from state
        let payload = {
            email: email,
            password: password,
            confirmPassword: confirmPassword,
            firstName: firstName,
            lastName: lastName,
        }

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            // credentials: 'include',
            body: JSON.stringify(payload),
        }

        // make a request
        fetch(`${process.env.REACT_APP_BACKEND}/api/signup`, requestOptions)
            // convert response to json 
            .then((response) => response.json())
            .then((data) => {
                // if there IS an error 
                if (data.error) {
                    setAlertClassName("alert-danger"); // show error class
                    setAlertMessage(data.message);
                } else { // if there is NO error
                    setAlertClassName("d-none"); // hide alert if it was
                    setAlertMessage("");
                    Swal.fire({ // message to confirm email
                        title: 'Confirm your email!',
                        text: 'Link has been sent to your email',
                        icon: 'info',
                        confirmButtonText: 'OK'
                    })
                    navigate("/");
                }
            })
            // if there is an unexpected error
            .catch(error => {
                setAlertClassName("alert-danger");
                setAlertMessage(error);
            })
    }

    return (
        <div className="col-md-6 offset-md-3">
            <h2>Registration</h2>
            <hr />
            <form onSubmit={handleSubmit}>
                <Input
                    title="First Name"
                    type="text"
                    className="form-control"
                    name="first_name"
                    autoComplete="off"
                    onChange={(event) => setFirstName(event.target.value)}
                />
                <Input
                    title="Last Name"
                    type="text"
                    className="form-control"
                    name="last_name"
                    autoComplete="off"
                    onChange={(event) => setLastName(event.target.value)}
                />
                <Input
                    title="Email Address"
                    type="email"
                    className="form-control"
                    name="email"
                    autoComplete="email-new"
                    onChange={(event) => setEmail(event.target.value)}
                />
                <Input
                    title="Password"
                    type="password"
                    className="form-control"
                    name="password"
                    autoComplete="password-new"
                    onChange={(event) => setPassword(event.target.value)}
                />
                <Input
                    title="Repeat password"
                    type="password"
                    className="form-control"
                    name="password"
                    autoComplete="password-new"
                    onChange={(event) => setConfirmPassword(event.target.value)}
                />
                <hr />

                <input
                    type="submit"
                    className="btn btn-primary"
                    value="Sign Up"
                />
            </form>
        </div>
    )
}

export default SignUp;